import { RouterProvider } from 'react-router';

import { router } from './router';

import './common/main.scss';

const App = () => {
  return <RouterProvider router={router} />;
};

export default App;
